module.exports = __webpack_public_path__ + "public/files/img/calendar.00964641.png";